import React from 'react';
import pt from 'prop-types';

export default function Holiday({
  cartId,
  optionId,
  packageId,
  schoolId,
  studentId,
  orderPackage,
  onSave,
}) {
  return (
    <div></div>
  );
}

Holiday.defaultProps = {};

Holiday.propTypes = {
  cartId: pt.string.isRequired,
  optionId: pt.string.isRequired,
  packageId: pt.string.isRequired,
  schoolId: pt.string.isRequired,
  studentId: pt.string.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  orderPackage: pt.object.isRequired,
  onSave: pt.func.isRequired,
};
